import {useState, useEffect} from "react";

export const Btn = ({targetDate, labelBefore, url}) => {
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const target = new Date(targetDate);
      if (now >= target) {
        setIsExpired(true);
      }
    };

    checkTime();
    const timer = setInterval(() => {
      checkTime();
      if (isExpired) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, isExpired]);

  if (isExpired) {
    return null;
  }

  const linkStyle = {
    backgroundColor: "#e60012",
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" style={linkStyle} className="appBtn">
      {labelBefore}
    </a>
  );
};
